import { Link } from 'react-router';
import { getPeriodEndAt, getQuarterStartAt, toFullDayDateString } from '@/utils/datetime';

interface QuarterNavigationItemProps {
  quarterStartAt: Date;
  label: string;
  thisQuarterStartAt: Date;
}

function QuarterNavigationItem({
  quarterStartAt,
  label,
  thisQuarterStartAt,
}: QuarterNavigationItemProps) {
  const isCurrentQuarter =
    quarterStartAt.getTime() === thisQuarterStartAt.getTime();
  const isFutureQuarter = quarterStartAt > thisQuarterStartAt;

  const className = [
    'flex h-7 items-center justify-center rounded border px-2 text-[13px] border-muted-background hover:bg-muted hover:text-black',
    isCurrentQuarter ? 'underline' : '',
    isFutureQuarter ? 'text-muted-foreground' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Link to={`/quarter/${toFullDayDateString(quarterStartAt)}`} className={className}>
      {label}
    </Link>
  );
}

interface QuarterNavigationForYearProps {
  yearStartAt: Date;
}

export function QuarterNavigationForYear({
  yearStartAt,
}: QuarterNavigationForYearProps) {
  const q1StartAt = yearStartAt;
  const q2StartAt = getPeriodEndAt(q1StartAt, 'quarter');
  const q3StartAt = getPeriodEndAt(q2StartAt, 'quarter');
  const q4StartAt = getPeriodEndAt(q3StartAt, 'quarter');

  const thisQuarterStartAt = getQuarterStartAt(new Date());

  const quarters = [
    { startAt: q1StartAt, label: 'Q1' },
    { startAt: q2StartAt, label: 'Q2' },
    { startAt: q3StartAt, label: 'Q3' },
    { startAt: q4StartAt, label: 'Q4' },
  ];

  return (
    <div className="flex gap-1">
      {quarters.map(({ startAt, label }) => (
        <QuarterNavigationItem
          key={toFullDayDateString(startAt)}
          quarterStartAt={startAt}
          label={label}
          thisQuarterStartAt={thisQuarterStartAt}
        />
      ))}
    </div>
  );
}
